// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.UploadModal_boxModal__OGaGi {
  animation: UploadModal_init__i\\+ess 0.3s;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.UploadModal_boxModal__OGaGi .UploadModal_exit__ru979 {
  animation: UploadModal_init2__dAaFm 0.3s both;
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
}

.UploadModal_boxModal__OGaGi .UploadModal_exit__ru979 .UploadModal_exitIcon__5GeJO {
  transition: 0.3s;
}

.UploadModal_boxModal__OGaGi .UploadModal_exit__ru979 .UploadModal_exitIcon__5GeJO:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.UploadModal_boxModal__OGaGi .UploadModal_titleModal__R4UrR {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.UploadModal_boxModal__OGaGi .UploadModal_titleModal__R4UrR p {
  font-size: 1.5rem;
  margin: 0;
}

.UploadModal_boxModal__OGaGi .UploadModal_titleModal__R4UrR span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.UploadModal_boxModal__OGaGi .UploadModal_drawNumber__BCpaS {
  animation: UploadModal_init2__dAaFm 0.3s both 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 20px;
  height: 100px;
}

.UploadModal_boxModal__OGaGi .UploadModal_drawNumber__BCpaS .UploadModal_drawSelected__9X5iE {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 300;
  margin-top: 20px;
  margin-bottom: 20px;
}

.UploadModal_boxModal__OGaGi .UploadModal_drawNumber__BCpaS .UploadModal_drawSelected__9X5iE .UploadModal_draw__G9yIl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.UploadModal_boxModal__OGaGi .UploadModal_drawNumber__BCpaS .UploadModal_drawSelected__9X5iE .UploadModal_draw__G9yIl p {
  margin: 0 0 10px 0;
  font-size: 1.3rem;
  font-weight: 300;
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn {
  animation: UploadModal_init2__dAaFm 0.3s both 0.5s;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  margin: 30px;
  margin-bottom: 0px;
  border: 3px solid rgba(169, 169, 169, 0.594);
  border-radius: 10px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn:hover {
  scale: 1.02;
  border: 3px solid rgba(111, 111, 111, 0.682);
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn .UploadModal_uploadIcon__DLIF4 {
  transform: translateX(55px);
  transition: 0.3s 0.2s;
  opacity: 1;
  filter: drop-shadow(0px 10px 15px -3px rgba(0, 0, 0, 0.1));
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn:hover .UploadModal_uploadIcon__DLIF4 {
  transform: translateX(0px);
  scale: 1.1;
  transition: 0.3s;
  transform: translateY(0px);
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn .UploadModal_textUpload__kXcEf {
  transition: 0.3s;
  opacity: 0;
  transform: translateY(20px);
  margin-top: 15px;
  margin: 0;
  font-size: 1.2rem;
  font-weight: 400;
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn:hover .UploadModal_textUpload__kXcEf {
  transition: 0.3s 0.2s;
  opacity: 1;
  transform: translateY(0px);
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_button__9c7ni {
  animation: UploadModal_init2__dAaFm 0.3s both 0.6s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin-top: 20px;
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_button__9c7ni p {
  margin: 10px 0 0 0;
  color: #5a5a5a80;
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn .UploadModal_itemsFile__\\+JDEk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.UploadModal_boxModal__OGaGi .UploadModal_filters__1\\+tzG .UploadModal_uploadContainer__YqvIn .UploadModal_itemsFile__\\+JDEk p {
  margin: 0;
  margin-top: 5px;
  transition: 0.3s;
  opacity: 1;
  font-size: 20px;
  font-weight: 400;
}

@media screen and (max-width: 900px) {
  .UploadModal_boxModal__OGaGi {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes UploadModal_init__i\\+ess {
  0% {
    top: 55%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}

@keyframes UploadModal_init2__dAaFm {
  0% {
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/VentasTelekino/UploadModal/UploadModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,wCAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,6CAA0B;EAC1B,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kDAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kDAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,kDAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.boxModal .exit {\n  animation: init2 0.3s both;\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.5rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .drawNumber {\n  animation: init2 0.3s both 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  height: 100px;\n}\n\n.boxModal .drawNumber .drawSelected {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 300;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.boxModal .drawNumber .drawSelected .draw {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .drawNumber .drawSelected .draw p {\n  margin: 0 0 10px 0;\n  font-size: 1.3rem;\n  font-weight: 300;\n}\n\n.boxModal .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.boxModal .filters .uploadContainer {\n  animation: init2 0.3s both 0.5s;\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100px;\n  margin: 30px;\n  margin-bottom: 0px;\n  border: 3px solid rgba(169, 169, 169, 0.594);\n  border-radius: 10px;\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.boxModal .filters .uploadContainer:hover {\n  scale: 1.02;\n  border: 3px solid rgba(111, 111, 111, 0.682);\n}\n\n.boxModal .filters .uploadContainer .uploadIcon {\n  transform: translateX(55px);\n  transition: 0.3s 0.2s;\n  opacity: 1;\n  filter: drop-shadow(0px 10px 15px -3px rgba(0, 0, 0, 0.1));\n}\n\n.boxModal .filters .uploadContainer:hover .uploadIcon {\n  transform: translateX(0px);\n  scale: 1.1;\n  transition: 0.3s;\n  transform: translateY(0px);\n}\n\n.boxModal .filters .uploadContainer .textUpload {\n  transition: 0.3s;\n  opacity: 0;\n  transform: translateY(20px);\n  margin-top: 15px;\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n.boxModal .filters .uploadContainer:hover .textUpload {\n  transition: 0.3s 0.2s;\n  opacity: 1;\n  transform: translateY(0px);\n}\n\n.boxModal .filters .button {\n  animation: init2 0.3s both 0.6s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n  margin-top: 20px;\n}\n\n.boxModal .filters .button p {\n  margin: 10px 0 0 0;\n  color: #5a5a5a80;\n}\n\n.boxModal .filters .uploadContainer .itemsFile {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .filters .uploadContainer .itemsFile p {\n  margin: 0;\n  margin-top: 5px;\n  transition: 0.3s;\n  opacity: 1;\n  font-size: 20px;\n  font-weight: 400;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(50px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `UploadModal_boxModal__OGaGi`,
	"init": `UploadModal_init__i+ess`,
	"exit": `UploadModal_exit__ru979`,
	"init2": `UploadModal_init2__dAaFm`,
	"exitIcon": `UploadModal_exitIcon__5GeJO`,
	"titleModal": `UploadModal_titleModal__R4UrR`,
	"drawNumber": `UploadModal_drawNumber__BCpaS`,
	"drawSelected": `UploadModal_drawSelected__9X5iE`,
	"draw": `UploadModal_draw__G9yIl`,
	"filters": `UploadModal_filters__1+tzG`,
	"uploadContainer": `UploadModal_uploadContainer__YqvIn`,
	"uploadIcon": `UploadModal_uploadIcon__DLIF4`,
	"textUpload": `UploadModal_textUpload__kXcEf`,
	"button": `UploadModal_button__9c7ni`,
	"itemsFile": `UploadModal_itemsFile__+JDEk`
};
export default ___CSS_LOADER_EXPORT___;
